export class PartnerModel {
    _id?: String;
    name?: String;
    type?: String;
    commission?: String;
    username?: String;
    email?: String;
    role?: String;
    status?: String;
    accountNumber?: String;
    routingNumber?: String;
    branch?: String;
    isRefundEnabled?: Boolean;
    isDisputeEnabled?: Boolean;
    destinationCountries?: String[];
    originationCountryId?: String;
    logoPath?: String;
    services?: String;
    remittanceCommission?: Number;
    createdAt?: Number;
    updatedAt?: Number;
}